import { render } from "./HospitalsEdit.vue?vue&type=template&id=ea17aeca&scoped=true"
import script from "./HospitalsEdit.vue?vue&type=script&lang=js"
export * from "./HospitalsEdit.vue?vue&type=script&lang=js"

import "./HospitalsEdit.vue?vue&type=style&index=0&id=ea17aeca&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea17aeca"]])

export default __exports__